// extracted by mini-css-extract-plugin
export default {"container":"TextContent_container__ku49I","heading":"TextContent_heading__BqLVB"};